import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getter'
import VuexPersistence from 'vuex-persist'
import config from '@/config'
Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    parentActiveTab: state.parentActiveTab,
    childActiveTab: state.childActiveTab,
    menus: state.menus,
    cosId: state.cosId,
    cos: state.cos,
    picAddr: state.uploadAddr,
    areaTree: state.areaTree,
    // obWebUrl: state.obWebUrl,
    webLoginUser: state.webLoginUser,
    searchinfo: state.searchinfo
  }),
})

const store = new Vuex.Store({
  state: {
    parentActiveTab: '',
    childActiveTab: '',
    searchinfo: '',
    uploadAddr: config.uploadAddr,
    obWebUrl: config.obWebUrl,
    cosId: '',
    cos: {},
    areaTree: '',
    webLoginUser: '',
    menus: '',
    shownav: false
  },
  modules: {},
  getters,
  mutations: {
    changeState(state, opts) {
      Object.keys(opts).map((item) => {
        // console.log(key)
        state[item] = opts[item]
      })
      // window.localStorage.setItem("obweb_state", JSON.stringify(state))
    }
  },
  plugins: [vuexLocal.plugin]
})

export default store
